<template>
	<div class="flex flex-col gap-4">
		<h2 class="pl-3 text-base font-medium leading-[24px]">
			Explore por regiões
		</h2>
		<div class="flex flex-col gap-2">
			<button
				v-for="city in cities"
				:key="city.slug + city.state"
				class="group flex items-start justify-between p-3 transition-all hover:bg-primary-light-4"
				:class="{
					'bg-primary-light-4': city.slug === selectedCity?.slug
				}"
				@click="handleClick(city)"
			>
				<span class="text-sm leading-[21px]">
					{{ getFormattedCityName(city) }}
				</span>
				<IconMaterialSymbolsLightChevronRight
					class="size-6 text-beige opacity-0 transition-opacity"
					:class="{
						'opacity-100': city.slug === selectedCity?.slug
					}"
				/>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { City } from '.';
import { useEvents } from '~/composables/events/useEvents';

type Props = {
	cities: City[];
};

defineProps<Props>();

const selectedCity = defineModel<City | null>('selectedCity', {
	default: null
});

const getFormattedCityName = (city: City) => {
	return `${city.name} - ${city.state}`;
};

const { trackHeader } = useEvents();

const handleClick = (city: City) => {
	if (city.slug === selectedCity.value?.slug) {
		selectedCity.value = null;
		return;
	}
	selectedCity.value = city;
	trackHeader.handleEventMenuHeaderClick({
		clickedButton: getFormattedCityName(city),
		action: 'buy',
		clickRegion: true
	});
};
</script>
